export default __webpack_public_path__ + "static/media/1.e7a48e70.jpeg";